export default __webpack_public_path__ + "static/media/training_battle.9fe46f89.jpg";